// src/resources/images.js
const images = {
    logo: require("./logo.png"),
    home: require("./home.png"),
    me: require("./me.jpeg"),
    mail: require("./email.png"),
    linkedin: require("./linkedin.png"),
    git: require("./git.png"),
    azure: require("./azure.png"),
    android: require("./android.webp"),
    cplus: require("./cplus.png"),
    eclipse: require("./eclipse.png"),
    flutter: require("./flutter.jpg"),
    typescript: require("./typescript.png"),
    java: require("./java.jpg"),
    js: require("./js.png"),
    react: require("./react.png"),
    mysql: require("./mysql.jpg"),
    php: require("./php.png"),
    python: require("./python.webp"),
    swagger: require("./swagger.png"),
    swift: require("./swift.png"),
    firebase: require("./firebase.jpg"),
    node: require("./node.jpeg"),
    spain: require("./spain.webp"),
    uk: require("./uk.png"),
    germany: require("./germany.png"),
    livemed: require("./livemed.png"),
    deloitte: require("./deloitte.png"),
    imagineapps: require("./imagineapps.png"),
    rocket: require("./rocket.png"),
    cv: require("./cv.png"),
  };
  
  export default images;